import React, {useEffect, useState} from 'react'
import Loader from "../../../../Loader/Loader";
import Header from "../../../layout/header";
import BottomMenu from "../../../layout/bottomMenu";
import SuccessModal from "../../../CustomModal/Success";
import FailedModal from "../../../CustomModal/Failed";
import useLatLng from "../../../../hooks/uselatlng/uselatlng";
import FileUpload from "../../../FileUploads/FileUpload";
import {toast} from 'react-toastify';
import DashboardMenu from "../../../layout/dashboardMenu";

const AccountNewActivity = ({
                                    saveActivity,
                                    documentUploadUrlPublic,
                                    saveNewActivity=[],
                                    documentUrlDataPublic,
                                    history,
                                    match,
                                    accountActivity,
                                    newActivity,
                                    getActivity
                     }) => {
    const islatlng = useLatLng();
    const [isLoading, setIsLoading] = useState(false)
    const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
    const [isFailedModalOpen, setIsFailedModalOpen] = useState(false);
    const [countToOpenModal, setCountToOpenModal] = useState(0)
    const [mapLocation, setMapLocation] = useState({
        address: 'Delhi',
        lat: 0,
        lng: 0,
    });
    const [isAllow, setIsAllow] = useState(false);
    const [inputList, setInputList] = useState([{
        activity_type_id: '',
        activity_date: '',
        meta_data: {},
        lat:'',
        long:'',
        next_activity_type_id: '',
        next_activity_date: '',
        description:''
    }])

    useEffect(() => {
        (async () => {
            setIsLoading(true)
            await getActivity()
            setIsLoading(false)
        })()
    }, [])

    useEffect(() => {
        if (islatlng === false) {
            setIsAllow(true);
        } else {
            setIsAllow(false);
        }
        var lati = Number(islatlng?.lat);
        var langi = Number(islatlng?.lng);
        if (!isNaN(lati) && !isNaN(langi)) {
            setMapLocation({
                address: 'Delhi6',
                lat: Number(islatlng?.lat),
                lng: Number(islatlng?.lng),
            });
        }
    }, [islatlng]);

    const handleInput = (key, val, metaKey ,e) => {
        let list = [...inputList]
        if (key === 'meta_data') {
            if(e.target !== undefined && e.target.selectedOptions !== undefined){
                let desc = e.target.selectedOptions[0].text;
                inputList[0][key][metaKey] = desc
                inputList[0][key][metaKey+"_id"] = val
            }else{
                inputList[0][key][metaKey] = val
            }
        } else {
            inputList[0][key] = val
        }
        setInputList(list)
    }

    useEffect(() => {
        setIsFailedModalOpen(false)
        setIsSuccessModalOpen(false)
        if (saveNewActivity?.status === 200) {
            setIsSuccessModalOpen(true)
        } else if (saveNewActivity?.status !== undefined && saveNewActivity?.status !== 200) {
            setCountToOpenModal(countToOpenModal + 1)
            setIsFailedModalOpen(true)
        }
    }, [saveNewActivity])

    const handleSubmit = async (e) => {
        e.preventDefault()
        let list = inputList[0]
        if(list['activity_type_id'] === '' && list['next_activity_type_id'] === ''){
            toast.error("Please choose activity type or next activity type is required")
            return false
        }

        if(list['activity_type_id'] !== '' && list['activity_date'] === ''){
            toast.error("Please choose activity date")
            return false
        }

        if(list['next_activity_type_id'] !== '' && list['next_activity_date'] === ''){
            toast.error("Please choose next activity date")
            return false
        }

        list['account_id'] = match?.params?.account_id
        list['activity_type'] = 'account'
        list['lat'] = islatlng?.lat
        list['long'] = islatlng?.lng
        if(list['long'] == null || list['lat'] == null){
            toast.error('Please enable your location');
        }
        setIsLoading(true)
        await newActivity(list)
        setIsLoading(false)
    }

    return (
        <>
            <SuccessModal
                isOpen={isSuccessModalOpen}
                msg={saveNewActivity?.message}
                url={`account-activity-list/${match?.params?.account_id}`}
            />


            <FailedModal
                isOpen={isFailedModalOpen}
                msg={saveNewActivity?.message}
                countToOpenModal={countToOpenModal}
            />
            <Loader isLoading={isLoading}/>
            <div id="wrapper">
                <DashboardMenu/>
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <Header
                            title={"Activity"}
                            history={history}
                        />
                        {/*BODY*/}
                        <div className="container-fluid common-bg">
                            <form onSubmit={(e) => handleSubmit(e)}>
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="row">
                                            <div className="col-md-12">
                                                <>
                                                    <div
                                                        className="d-sm-flex align-items-center justify-content-between com-sub-heading">
                                                        <h1 className="h3 mb-0 text-black-100"><b>Close Your Activity</b></h1>
                                                    </div>
                                                    <div className="card-body bg-white">
                                                        <div className="user">
                                                            <div className="form-group row">
                                                                <div className="col-sm-6 mt-1 float-field">
                                                                    <select
                                                                        className="form-control form-control-user"
                                                                        onChange={(e) => {
                                                                            handleInput('activity_type_id', e.target.value, e)
                                                                        }} >
                                                                        <option value="">Select Activity</option>
                                                                        {accountActivity && accountActivity?.data !== undefined  && accountActivity?.data.map((val) => {
                                                                            return (
                                                                                <option
                                                                                    value={val?.id}>{val.name}</option>
                                                                            )
                                                                        })}
                                                                    </select>
                                                                    <label className="large-label float-lb">
                                                                        Activity Type
                                                                    </label>
                                                                </div>
                                                                <div className="col-sm-6 mt-1 float-field">
                                                                    <input type="date"
                                                                           className="form-control form-control-user"
                                                                           placeholder=" "
                                                                           onChange={(e) => {
                                                                               handleInput('activity_date', e.target.value, e)
                                                                           }}
                                                                           id="validationCustom01"
                                                                    />
                                                                    <label className="large-label float-lb">
                                                                        Activity Date
                                                                    </label>
                                                                </div>
                                                                <div className="col-sm-6 mt-1 float-field mb-3">
                                                            <textarea
                                                                className="form-control form-control-user cus-red"
                                                                placeholder=" Remarks*"
                                                                onChange={(e) => {
                                                                    handleInput('meta_data', e.target.value, 'remark' ,e)
                                                                }}
                                                                id="validationCustom01"
                                                                rows="4" cols="50"
                                                            />
                                                                    <label className="large-label float-lb">
                                                                        {/*Description*/}
                                                                    </label>
                                                                </div>
                                                                <div className="col-sm-6 mtk-075 float-field mb-3">
                                                                    <FileUpload
                                                                        id={"addAttachment"}
                                                                        accept=".png,.jpg,.jpeg"
                                                                        documentUploadUrl={documentUploadUrlPublic}
                                                                        documentUrlData={documentUrlDataPublic}
                                                                        onChange={(e, val) => {
                                                                            handleInput('meta_data', e, 'Document',e)
                                                                        }}
                                                                        prefilledFilename={""}
                                                                        multiple={true}
                                                                    >
                                                                        File Attachment
                                                                    </FileUpload>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div
                                                        className="d-sm-flex align-items-center justify-content-between com-sub-heading">
                                                        <h1 className="h3 mb-0 text-black-100"><b>Schedule Future Activity</b></h1>
                                                    </div>
                                                    <div className="card-body bg-white">
                                                        <div className="user">
                                                            <div className="form-group row">
                                                                <div className="col-sm-6 mtk-075 float-field" style={{marginTop:"16px !important"}}>
                                                                    <select
                                                                        className="form-control form-control-user"
                                                                        onChange={(e) => {
                                                                            handleInput('next_activity_type_id', e.target.value, e)
                                                                        }} >
                                                                        <option value="">Select Activity</option>
                                                                        {accountActivity && accountActivity?.data !== undefined  && accountActivity?.data.map((val) => {
                                                                            return (
                                                                                <option
                                                                                    value={val?.id}>{val.name}</option>
                                                                            )
                                                                        })}
                                                                    </select>
                                                                    <label className="large-label float-lb">
                                                                        Activity
                                                                    </label>
                                                                </div>
                                                                <div className="col-sm-6 mtk-05 float-field">
                                                                    <input type="date"
                                                                           className="form-control form-control-user"
                                                                           placeholder=" "
                                                                           onChange={(e) => {
                                                                               handleInput('next_activity_date', e.target.value, e)
                                                                           }}
                                                                           id="validationCustom01"
                                                                    />
                                                                    <label className="large-label float-lb">
                                                                        Date
                                                                    </label>
                                                                </div>
                                                                <div className="col-sm-6 mtk-025 float-field">
                                                            <textarea
                                                                className="form-control form-control-user"
                                                                placeholder=" Description"
                                                                onChange={(e) => {
                                                                    handleInput('description', e.target.value, '' ,e)
                                                                }}
                                                                id="validationCustom01"
                                                                rows="4" cols="50"
                                                            />
                                                                    <label className="large-label float-lb">
                                                                        {/*Description*/}
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>
                                            </div>
                                        </div>
                                        {/*<div className="mb-0 bg-white hvh-100">*/}
                                        {/*    <div className="card-body">*/}
                                        {/*        <div className="user mt-4">*/}
                                        {/*            <div className="form-group row">*/}

                                        {/*            </div>*/}
                                        {/*        </div>*/}
                                        {/*    </div>*/}
                                        {/*</div>*/}
                                        {/*<div class="d-flex">*/}
                                        {/*<div className="col-md-12 mt-4">*/}
                                        {/*    <button className="btn btn-primary btn-user btn-block submit-btn">*/}
                                        {/*        Submit*/}
                                        {/*    </button>*/}
                                        {/*</div>*/}
                                        {/*</div>*/}
                                        <div className="col-md-12 mt-4">
                                            <button className="btn btn-primary btn-user btn-block submit-btn">
                                                Submit
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AccountNewActivity